import { render, staticRenderFns } from "./LevantamientosStatisticsUser.vue?vue&type=template&id=63f67f53&scoped=true"
import script from "./LevantamientosStatisticsUser.vue?vue&type=script&lang=ts"
export * from "./LevantamientosStatisticsUser.vue?vue&type=script&lang=ts"
import style0 from "./LevantamientosStatisticsUser.vue?vue&type=style&index=0&id=63f67f53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f67f53",
  null
  
)

export default component.exports